import type { SVGProps } from 'react'

export const IconGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 262"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <title>Google Logo</title>
    <path
      d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      fill="#4285F4"
    />
    <path
      d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      fill="#34A853"
    />
    <path
      d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
      fill="#FBBC05"
    />
    <path
      d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      fill="#EB4335"
    />
  </svg>
)

export const TwitterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <title>X</title>
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
)

export function DiscordIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <title>Discord</title>
      <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
    </svg>
  )
}

export function LinkedInIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <title>LinkedIn</title>
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  )
}

export function StopCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <title>Stop</title>
      <path
        fillRule="evenodd"
        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6-2.438c0-.724.588-1.312 1.313-1.312h4.874c.725 0 1.313.588 1.313 1.313v4.874c0 .725-.588 1.313-1.313 1.313H9.564a1.312 1.312 0 0 1-1.313-1.313V9.564Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export function CrownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="currentColor"
      {...props}
    >
      <title>Crown</title>
      <path
        d="M1.74805 4.05004L1.77805 3.96604C1.85605 3.73204 2.06005 3.57604 2.31205 3.55804C2.54005 3.54004 2.76805 3.67804 2.87605 3.88804C2.98405 4.10404 2.95405 4.35604 2.79805 4.54204C2.78005 4.56004 2.76205 4.58404 2.73805 4.60804C3.18205 4.87804 3.62005 5.14804 4.05805 5.41804C4.22605 5.52004 4.39405 5.62204 4.55605 5.72404C4.65205 5.77804 4.72405 5.76604 4.77805 5.67004C5.28805 4.74004 5.79205 3.82204 6.30205 2.89204C6.08005 2.77804 5.94205 2.61004 5.92405 2.35804C5.91805 2.17804 5.97805 2.02804 6.10405 1.90804C6.35605 1.66804 6.76405 1.68604 6.98005 1.95604C7.23205 2.26204 7.14205 2.62804 6.74005 2.89804C6.87205 3.13804 7.00405 3.37804 7.13605 3.61204L8.23405 5.61004C8.31805 5.76604 8.37205 5.77804 8.52205 5.68804C9.08605 5.34004 9.65605 4.99204 10.22 4.65004C10.244 4.63204 10.274 4.62004 10.304 4.59604C10.184 4.47604 10.112 4.34404 10.106 4.18204C10.088 3.87604 10.298 3.61204 10.592 3.55804C10.898 3.50404 11.18 3.67804 11.276 3.97804C11.282 4.00204 11.294 4.02604 11.3 4.05004V4.26004C11.204 4.56604 11.006 4.74604 10.664 4.75204L10.628 4.86004C10.298 5.99404 9.96205 7.13404 9.63205 8.27404C9.59005 8.42404 9.53605 8.46004 9.38605 8.46004H3.66805C3.50605 8.46004 3.45805 8.42404 3.41605 8.27404L2.60605 5.50204C2.53405 5.25004 2.46205 5.00404 2.38405 4.75204C2.13205 4.75204 1.94005 4.65004 1.82005 4.43404C1.79005 4.38004 1.77205 4.32004 1.74805 4.26604V4.05004ZM6.50005 9.56404H9.17605C9.41605 9.56404 9.60205 9.70204 9.63205 9.88804C9.65605 10.074 9.50605 10.248 9.27805 10.29C9.24805 10.296 9.21205 10.296 9.17605 10.296H3.82405C3.62005 10.296 3.44605 10.194 3.39205 10.044C3.33205 9.89404 3.38605 9.72004 3.54805 9.63604C3.63205 9.59404 3.74605 9.56404 3.84205 9.56404H6.50005Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FeatureIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Feature</title>
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1512_18597)">
        <rect
          x="1.69983"
          y="11.5469"
          width="7"
          height="7"
          rx="1"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M11 15C11 12.7909 12.7909 11 15 11V11C17.2091 11 19 12.7909 19 15V15C19 17.2091 17.2091 19 15 19V19C12.7909 19 11 17.2091 11 15V15Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M14.1588 2.3085C14.5525 1.69618 15.4475 1.69618 15.8412 2.3085L18.5095 6.45924C18.9373 7.12475 18.4595 8 17.6683 8H12.3317C11.5405 8 11.0627 7.12475 11.4905 6.45924L14.1588 2.3085Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M5.19983 2.54642C1.06273 0.241552 -1.69533 5.77319 5.19983 9C10.716 5.77319 9.79662 0.241559 5.19983 2.54642Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  )
}

export function DiscordLineIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Discord</title>
      <mask
        id="mask0_1742_3990"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          x="0.0119048"
          y="0.0119048"
          width="19.9762"
          height="19.9762"
          fill="#D9D9D9"
          stroke="#111827"
          strokeWidth="0.0238095"
        />
      </mask>
      <g mask="url(#mask0_1742_3990)">
        <path
          d="M4.38086 5.97864C6.39276 4.70483 11.1785 3.40721 15.6071 5.99054"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M3.83301 13.4519C7.19015 15.7733 12.5473 16.059 16.1782 13.44"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <ellipse
          cx="7.23828"
          cy="10.8333"
          rx="1.5"
          ry="1.71429"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <ellipse
          cx="12.7617"
          cy="10.8333"
          rx="1.5"
          ry="1.71429"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M7.76216 4.28571L7.41692 3.16666C6.13121 3.29762 4.20264 3.84524 3.1193 4.72619C1.70264 6.95238 0.666985 10.869 0.666992 14.2976C1.75028 15.869 4.036 16.6667 5.67882 16.7738L6.89311 15.0714"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2378 4.28571L12.5831 3.16666C13.8688 3.29762 15.7974 3.84524 16.8807 4.72619C18.2974 6.95238 19.333 10.869 19.333 14.2976C18.2497 15.869 15.964 16.6667 14.3212 16.7738L13.1069 15.0714"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function Layout2Icon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Layout</title>
      <mask
        id="mask0_3336_7565"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3336_7565)">
        <mask id="path-2-inside-1_3336_7565" fill="white">
          <rect x="4" y="6" width="20" height="16" rx="1" />
        </mask>
        <rect
          x="4"
          y="6"
          width="20"
          height="16"
          rx="1"
          stroke="#4B5563"
          strokeWidth="2.4"
          mask="url(#path-2-inside-1_3336_7565)"
        />
        <path
          d="M16.6 14C16.6 13.7791 16.7791 13.6 17 13.6H21C21.2209 13.6 21.4 13.7791 21.4 14V19C21.4 19.2209 21.2209 19.4 21 19.4H17C16.7791 19.4 16.6 19.2209 16.6 19V14Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <path
          d="M16.6 11C16.6 11.2209 16.7791 11.4 17 11.4H21C21.2209 11.4 21.4 11.2209 21.4 11V9C21.4 8.77909 21.2209 8.6 21 8.6H17C16.7791 8.6 16.6 8.77909 16.6 9V11Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <mask id="path-5-inside-2_3336_7565" fill="white">
          <rect x="6" y="15" width="9" height="5" rx="1" />
        </mask>
        <rect
          x="6"
          y="15"
          width="9"
          height="5"
          rx="1"
          stroke="#4B5563"
          strokeWidth="2.4"
          mask="url(#path-5-inside-2_3336_7565)"
        />
        <path
          d="M6.6 9C6.6 8.77909 6.77909 8.6 7 8.6H14C14.2209 8.6 14.4 8.77909 14.4 9V13C14.4 13.2209 14.2209 13.4 14 13.4H7C6.77909 13.4 6.6 13.2209 6.6 13V9Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  )
}

export function TransferIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Transfer</title>
      <mask
        id="mask0_3336_7571"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3336_7571)">
        <path
          d="M1.6 10.5C1.6 10.2791 1.77909 10.1 2 10.1H9C9.22091 10.1 9.4 10.2791 9.4 10.5V17.5C9.4 17.7209 9.22091 17.9 9 17.9H2C1.77909 17.9 1.6 17.7209 1.6 17.5V10.5Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <path
          d="M18.6 10.5C18.6 10.2791 18.7791 10.1 19 10.1H26C26.2209 10.1 26.4 10.2791 26.4 10.5V17.5C26.4 17.7209 26.2209 17.9 26 17.9H19C18.7791 17.9 18.6 17.7209 18.6 17.5V10.5Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <path
          d="M10 14.5H17.5M17.5 14.5L14.4545 12M17.5 14.5L14.4545 17"
          stroke="#4B5563"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function MarginIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Margin</title>
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3882_8375)">
        <path d="M4 5H5.5V12H4V5Z" fill="#9FA4AE" />
        {/* <path d="M10.5 5H12V12H10.5V5Z" fill="#9FA4AE" /> */}
        <rect x="7.5" y="1" width="1" height="14" fill="#9FA4AE" />
      </g>
    </svg>
  )
}

export function PaddingIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Padding</title>
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3882_8397)">
        <path d="M3 5H4.5V12H3V5Z" fill="#9FA4AE" />
        {/* <path d="M11.5 5H13V12H11.5V5Z" fill="#9FA4AE" /> */}
        <rect x="2" y="1" width="1" height="14" fill="#9FA4AE" />
        {/* <rect x="13" y="1" width="1" height="14" fill="#9FA4AE" /> */}
      </g>
    </svg>
  )
}

export function ImageIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Image</title>
      <mask
        id="mask0_4053_9679"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4053_9679)">
        <rect
          x="3"
          y="4"
          width="14"
          height="12"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M15.0892 14L5.20711 14C4.76165 14 4.53857 13.4614 4.85355 13.1464L7.69337 10.3066C7.86931 10.1307 8.14786 10.1109 8.34692 10.2602L9.61999 11.215C9.83294 11.3747 10.1337 11.3396 10.3041 11.1351L12.0617 9.02601C12.2785 8.76583 12.6858 8.79194 12.8676 9.07766L15.511 13.2316C15.7228 13.5644 15.4837 14 15.0892 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DoubleTreeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Double Tree</title>
      <path
        d="M2.5 7.5H5.625M8.75 7.5H5.625M5.625 7.5V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.75 5H13.125M17.5 5H13.125M13.125 5V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function EditIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Edit</title>
      <mask
        id="mask0_12572_18952"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          fill="currentColor"
          stroke="currentColor"
        />
      </mask>
      <g mask="url(#mask0_12572_18952)">
        <path
          d="M1.76725 3.5C2.61544 3.27802 3.27802 2.61544 3.5 1.76725C3.72198 2.61544 4.38456 3.27802 5.23275 3.5C4.38456 3.72198 3.72198 4.38456 3.5 5.23275C3.27802 4.38456 2.61544 3.72198 1.76725 3.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.371212"
        />
        <path
          d="M14.5555 9.90918L14.2398 10.4344C13.7596 11.2331 13.7596 12.2315 14.2398 13.0302L14.5555 13.5554L14.0303 13.2396C13.2317 12.7595 12.2332 12.7595 11.4345 13.2396L10.9093 13.5554L11.2251 13.0302C11.7052 12.2315 11.7052 11.2331 11.2251 10.4344L10.9093 9.90918L11.4345 10.225C12.2332 10.7051 13.2317 10.7051 14.0303 10.225L14.5555 9.90918Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.371212"
        />
        <path
          d="M9.12843 9.97164L7.99991 11.3534C6.89991 12.7003 5.30993 13.555 3.57973 13.7296V13.7296C3.12936 13.775 2.72743 13.4468 2.68199 12.9964L2.56705 11.8571C2.46608 10.8564 2.76679 9.85655 3.40302 9.07754L8.41862 2.93629C9.29199 1.86691 10.8669 1.70801 11.9363 2.58138V2.58138C13.0057 3.45476 13.1646 5.02967 12.2912 6.09906L11.0261 7.64809"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}

export function ButtonIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Button</title>
      <rect
        x="1"
        y="5"
        width="18"
        height="10"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}
